import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import * as rdrLocales from 'react-date-range/dist/locale';

import { FormattedMessage, injectIntl } from 'react-intl';
import { Calendar } from 'react-date-range';
import Button from '../../../components/button';
import Collapsible from '../../../components/collapsible/Collapsible';
import Clickable from '../../../components/clickable/Clickable';

import styles from '../select_date_style.module.scss';

export const formatDate = date => date.toLocaleDateString('en-US', {
  day: 'numeric',
  month: 'long',
  year: 'numeric'
});
class SelectDate extends Component {
  child = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      title: new Date().toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }),
      selectedDate: new Date(props.selectDate)
    };
  }

  static getDerivedStateFromProps(props, state) {
    const { selectDate, noRange } = props;
    if (!state.init) {
      if (!noRange && !localStorage.getItem('shift_start') && !localStorage.getItem('position_date')) {
        return { title: 'Today', init: true };
      }
      if (selectDate) {
        if (!noRange && formatDate(new Date(selectDate)) === formatDate(new Date())) {
          return {
            title: 'Today',
            init: true
          };
        }
        return {
          title: `${formatDate(new Date(selectDate))}`,
          init: true
        };
      }
    }
    return state;
  }

  handleDateChange = (date) => {
    this.setState({ selectedDate: date });
  };

  equalDates = (d1, d2) => d1.getFullYear() === d2.getFullYear()
    && d1.getDate() === d2.getDate()
    && d1.getMonth() === d2.getMonth();

  applyFilters = () => {
    const { onDateChange, noRange } = this.props;
    const { selectedDate } = this.state;
    if (selectedDate) {
      if (!noRange && this.equalDates(selectedDate, new Date())) {
        this.setState({ title: 'Today' });
      } else {
        this.setState({ title: formatDate(selectedDate) });
      }
    }
    onDateChange(selectedDate);
    this.child.current.onItemClick();
  };

  render() {
    const language = localStorage.getItem('lang') || 'en';
    const { title, selectedDate } = this.state;
    const { handleDropdown, ShiftManagement, fromCom, selectDate, gates, gantt } = this.props;
    return (
      <div>
        <div className={styles.datefilter} style={ShiftManagement ? { marginRight: '68px' } : gantt && { height: '38px' }}>
          <div className={styles.right}>
            <Collapsible
              dateFilter
              ref={this.child}
              styleClasses={fromCom ? styles.comFilter : styles.dateHeader}
              title={gates? formatDate(new Date(selectDate)) :title}
              offset={400}
            >
              <div>
                <div className={styles.pickerWrapper}>
                  <Calendar
                    date={selectedDate}
                    color="rgba(58, 97, 168, 0.67)"
                    locale={rdrLocales[language]}
                    onChange={this.handleDateChange}
                  />
                  <div style={{ marginLeft: '252px', marginBottom: '10px' }}>
                    <Button
                      onClick={this.applyFilters}
                      translationID="inspections.filter.apply"
                      defaultText="Apply"
                      action="secondary"
                    />
                  </div>
                </div>
              </div>
            </Collapsible>
            {handleDropdown && (
              <Clickable
                className={styles.actionsBtn}
                onClick={() => handleDropdown()}
              >
                <FormattedMessage
                  id="workorders.list.filters"
                  defaultMessage="Filters "
                />
              </Clickable>
            )}
          </div>
        </div>
      </div>
    );
  }
}

/**
 *  Proptypes and default props
 */
SelectDate.propTypes = {
  onDateChange: PropTypes.func.isRequired
};

SelectDate.defaultProps = {};

export default injectIntl(SelectDate);
